import client from "./client";

export async function updateShippingOption(shippingTimeId: number) {
    const response = await client.post("/cart/shipping-option", {
        shipping_option: shippingTimeId,
    });

    return response.data;
}

export async function updateShippingRegion(inputs: Record<string, unknown>) {
    const response = await client.post("/cart/shipping-region", inputs);

    return response.data;
}
